import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'

import { getStockDaysColor } from 'utilities/price-evaluation'
import { media } from 'utilities/styled'

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizeByFactor(0.5)};
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.text};
`

const Days = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ theme }) => theme.sizings.lvl2};
  padding: ${({ theme }) => theme.sizeByFactor(0.25)};
  background-color: ${({ theme, $color }) => theme.colors[$color]};
  color: ${({ theme }) => theme.colors.textOnDarkBackground};
  font-size: ${({ theme }) => theme.smallFontSize};
  font-weight: 400;
  line-height: ${({ theme }) => theme.smallFontSize};

  ${media.tablet`
    font-weight: 500;
  `}
`

const Label = styled.span`
  font-size: ${({ theme }) => theme.baseFontSize};
  font-weight: ${({ theme }) => theme.baseFontWeight};
  line-height: ${({ theme }) => theme.baseLineHeight};
  white-space: nowrap;
`

/**
 * Shows the number of days a car is in stock, coloured by its 30-day step.
 */
const StockDaysBadge = ({ days, className, ...restProps }) => {
  const { t } = useTranslation()
  const color = getStockDaysColor(days)

  return (
    <Container className={className} {...restProps}>
      <Days $color={color}>{days}</Days>
      <Label>{t('stayDays')}</Label>
    </Container>
  )
}

StockDaysBadge.propTypes = {
  days: PropTypes.number.isRequired,
  className: PropTypes.string,
}

StockDaysBadge.defaultProps = {
  className: null,
}

export default StockDaysBadge
